import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { IAlert } from 'src/app/core/models/i-alert';
import { Subscription, Observable, timer } from 'rxjs';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
})
export class AlertComponent implements OnInit, OnDestroy {
  alertSubscription: Subscription = new Subscription();
  timerSubscription: Subscription = new Subscription();
  message: IAlert | null;
  timer: Observable<number>;
  alertDuration = 5000; // 5000 millisecond means 5 seconds
  constructor(public alertService: AlertService) {}

  ngOnInit() {
    this.alertSubscription = this.alertService
      .getAlert()
      .subscribe((message) => {
        if (!message) {
          this.message = null;
          return;
        }
        switch (message && message.type) {
          case 'success':
            message.cssClass = 'alert alert-success';
            break;
          case 'info':
            message.cssClass = 'alert alert-info';
            break;
          case 'warning':
            message.cssClass = 'alert alert-warning';
            break;
          case 'error':
            message.cssClass = 'alert alert-error';
            break;
        }
        this.message = message;
        this.setTimer();
      });
  }
  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
    this.timerSubscription.unsubscribe();
  }

  setTimer() {
    this.timer = timer(this.alertDuration);
    this.timerSubscription = this.timer.subscribe((res) => {
      this.alertService.clear();
      this.timerSubscription.unsubscribe();
    });
  }
}
